/**
 * Concordância de número nas mensagens que interpolam uma quantidade.
 *
 * Mora no protocolo pelo mesmo motivo que `items.ts` e `spells.ts`: vocabulário em
 * português que as **duas** pontas escrevem. E aqui a partilha não é teórica — o banco
 * escreve a mesma frase dos dois lados ao mesmo tempo. O servidor confirma "Você depositou
 * 1 moeda." enquanto o cliente redesenha "Saldo: 1 moeda" logo acima; duas cópias da regra
 * seriam duas chances de o jogador ler o singular de um lado e o plural do outro na mesma
 * tela. Nada disso atravessa o fio: é texto montado em cada ponta, zero byte no protocolo.
 *
 * O escopo termina aqui: uma palavra, duas formas, um número. Não há tabela de gênero, nem
 * artigo, nem concordância de adjetivo — nada disso foi pedido, e inventar gramática que
 * ninguém usa é código que só pode envelhecer errado.
 */
/**
 * "1 moeda", "2 moedas" — o número junto da palavra, na forma que o número pede.
 *
 * As duas formas vêm escritas à mão, e não derivadas de uma delas: em português a regra tem
 * exceção demais para a adivinhação valer a pena. Das quatro palavras que este repositório
 * pluraliza hoje, só "moeda/moedas" é regular — "item/itens" troca o radical,
 * "jogador/jogadores" ganha sílaba e "correção/correções" mexe no acento. Um `palavra + 's'`
 * erraria em três de quatro, e um mapa de regras seria mais código que as quatro palavras
 * que ele cobriria.
 */
export function counted(value, one, many) {
    // Só o 1 exato é singular: zero é plural em português ("0 moedas"), que é o engano mais
    // fácil de cometer. O `abs` cobre o negativo ("-1 moeda"), que nenhuma mensagem produz
    // hoje mas sairia errado em silêncio no dia em que alguém escrever uma perda com sinal.
    return `${value} ${Math.abs(value) === 1 ? one : many}`;
}
//# sourceMappingURL=text.js.map